function isInput(el) {
  return el instanceof HTMLInputElement;
}
function isCheckbox(el) {
  return isInput(el) && el.type === "checkbox";
}
function isSelect(el) {
  return el instanceof HTMLSelectElement;
}
const callbacks = /* @__PURE__ */ new Map();
function getCallback(name, code) {
  const key = code + name;
  if (!callbacks.has(key)) {
    callbacks.set(key, new Function("value", "target", code));
  }
  return callbacks.get(key);
}
export {
  getCallback,
  isCheckbox,
  isInput,
  isSelect
};
//# sourceMappingURL=utils.js.map
